import { ToggleGroup, ToggleGroupItem } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import type { BriefTemplateStartMode } from './useBriefTemplateIntakeShell';

const GENERATE: BriefTemplateStartMode = 'generate';
const BLANK: BriefTemplateStartMode = 'blank';

interface BriefTemplateStartModeChoiceProps {
  value: BriefTemplateStartMode;
  onChange: (value: BriefTemplateStartMode) => void;
  disabled?: boolean;
}

export function BriefTemplateStartModeChoice({
  value,
  onChange,
  disabled = false,
}: BriefTemplateStartModeChoiceProps) {
  const { t } = useTranslation('briefs');

  return (
    <ToggleGroup
      type="single"
      value={value}
      disabled={disabled}
      onValueChange={(next) => {
        // Radix emits '' when the active item is pressed again; a template always starts one way.
        if (next) onChange(next as BriefTemplateStartMode);
      }}
      aria-label={t('briefTemplateCreation.briefTemplateIntakeModal.howToStart')}
      spacing={1}
      size="sm"
      className="w-fit rounded-lg border border-border-light bg-secondary p-0.5"
    >
      <ToggleGroupItem
        value={GENERATE}
        className="rounded-md px-3 text-muted-foreground data-[state=on]:bg-card data-[state=on]:text-foreground"
      >
        {t('briefTemplateCreation.briefTemplateIntakeModal.generateWithAi')}
      </ToggleGroupItem>
      <ToggleGroupItem
        value={BLANK}
        className="rounded-md px-3 text-muted-foreground data-[state=on]:bg-card data-[state=on]:text-foreground"
      >
        {t('briefTemplateCreation.briefTemplateIntakeModal.startBlank')}
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
